import React from 'react';
import {connect} from 'react-redux';
import ContentTemplate from '../ContentTemplate';

const SelectedFrequencyContent = ({formContext, frequency}) => {
  const frequencyDefinition = formContext.frequencies.find(f => f.value === frequency);

  return <ContentTemplate html={frequencyDefinition?.contentTemplate} formContext={formContext} contentKey={`frequency:${frequency}`} />;
};

const mapStateToProps = (state, ownProps) => {
  return {
    frequency: ownProps.frequency || state.form.donate_data_frequency
  };
};

export default connect(mapStateToProps)(SelectedFrequencyContent);
